<template>
  <span>
    <nx-file-upload-wizard
      v-if="hasFileUpload"
      @dismiss="$emit('dismiss')"
      @entityCreated="$emit('entityCreated', $event)"
      :config="config"
      :active="active"
      :enable-create-and-continue="enableCreateAndContinue"
      :additional-payload="additionalPayload"
      :entity="config.name"
    ></nx-file-upload-wizard>

    <component
      v-else-if="hasWizardComponent"
      v-bind="$attrs"
      :is="config.component"
      :active="active"
      :entity="entity"
      :enable-create-and-continue="enableCreateAndContinue"
      :additional-payload="additionalPayload"
      @dismiss="$emit('dismiss')"
      @entityCreated="$emit('entityCreated', $event)"
    ></component>

    <nx-config-wizard
      v-else
      :entity="entity"
      :active="active"
      :config="config"
      :enable-create-and-continue="enableCreateAndContinue"
      :additional-payload="additionalPayload"
      :default-value="defaultValue"
      @dismiss="$emit('dismiss')"
      @entityCreated="$emit('entityCreated', $event)"
    ></nx-config-wizard>
  </span>
</template>

<script>
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import NxConfigWizard from '@/modules/entity/wizard/ConfigWizard';
import Loadable from '@/mixins/loadable';
import isEmpty from 'lodash/isEmpty';
import { mapState, mapGetters } from 'vuex';
import NxFormScopeGenerator from '@/modules/form/FormScopeGenerator';
import NxFileUploadWizard from '@/modules/entity/wizard/FileUploadWizard';

export default {
  name: 'nx-entity-wizard',
  mixins: [Loadable],
  components: {
    NxFileUploadWizard,
    NxFormScopeGenerator,
    NxFullscreenDialog,
    NxConfigWizard,
  },
  props: {
    // article, image, section, etc
    entity: {
      type: String,
      required: true,
    },
    customConfig: {
      type: Array,
    },
    mergeFieldsConfig: {
      type: Array,
      default: () => ([]),
    },
    additionalPayload: {
      type: Object,
      default: (() => {}),
    },
    // true si pinta un botón create normal, ej: selectores de clipping
    enableCreateAndContinue: {
      type: Boolean,
      default: () => false,
    },
    active: {
      type: Boolean,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: (() => { }),
    },
  },
  computed: {
    ...mapState(['siteId']),
    ...mapGetters(['context', 'getWizard']),
    config() {
      const wizard = this.getWizard(this.entity);
      if (!isEmpty(this.customConfig)) {
        return {
          name: this.entity,
          ...(wizard || {}),
          fieldsConfig: this.customConfig,
        };
      }
      if (wizard) {
        return this.mergeWizardConfig(wizard, this.mergeFieldsConfig);
      }
      return null;
    },
    hasWizardComponent() {
      return this.config && this.config.component && isEmpty(this.customConfig);
    },
    hasFileUpload() {
      if (!this.config || !this.config.fieldsConfig) {
        return false;
      }
      return this.config.fieldsConfig.find(
        field => field.component === 'FileUpload',
      );
    },
  },
  methods: {
    applyAutofocusParam(fields) {
      // Apply autofocus to the first component if none have it
      if (fields.length === 0
        || fields.find(field => field.params && field.params.autofocus)) {
        return fields;
      }
      const first = fields[0];
      if (!first.params) {
        first.params = {};
      }
      first.params.autofocus = true;
      return fields;
    },
    mergeWizardConfig(wizard, mergeFieldsConfig) {
      const fieldsConfig = (wizard.fieldsConfig || wizard.fields || [])
        .map((fieldConfig) => {
          const mergeField = mergeFieldsConfig.find(mergeFieldConfig => mergeFieldConfig.field === fieldConfig.field);
          return mergeField || fieldConfig || {};
        });
      this.applyAutofocusParam(fieldsConfig);
      return {
        ...wizard,
        fieldsConfig,
      };
    },
  },
};
</script>
